export default __webpack_public_path__ + "static/media/bag-icon.b97b52df.svg";